import { Typography } from 'antd'
import {
    TableOutlined
} from '@ant-design/icons';
import { Trans, useTranslation } from 'react-i18next';

export default function HelpTab() {
    const { t } = useTranslation("nearForests");

    return <>
        <Typography.Title level={4}>{t("ohjeitaOtsikko")}</Typography.Title>
        <p>
            {t("ohjeRivi1")}
        </p>
        <p>
            <Trans i18nKey="nearForests:ohjeRivi2" components={{
                i: <TableOutlined />
            }}>
                Taulukossa (valikossa kohta <TableOutlined />) ilmoitetaan kartalla näkyvän alueen sisältämien metsien yhteispinta-ala. Tämä tieto saadaan
                Metsäkeskuksen ns. metsämaski-tiedoista. Lisäksi näytetään kartalla näkyvän alueen sisältämien lähimetsien pinta-ala ja niiden lukumäärä.
            </Trans>
        </p>
        <p>
            {t("ohjeRivi3")}
        </p>
        <p>
            {t("ohjeRivi4")}
        </p>
        <p>
            {t("ohjeRivi5")}
        </p>
        <p>
            {t("ohjeRivi6")}
        </p>
    </>
}